<template>
  <div>
    <div v-if="loading">
      <px-circular-loading />
    </div>
    <div v-if="!fornecedores.length && !loading" align="center" class="headline">
      Nenhum produto encontrado!
    </div>
    <v-expansion-panels
      v-if="fornecedores && fornecedores.length"
      class="rounded-card"
      multiple
      focusable>
        <v-expansion-panel
          active-class="rounded-card"
          v-for="(fornecedor, index) in fornecedores"
          :key="fornecedor.id">
          <v-expansion-panel-header>
            <v-row dense align="center">
              <v-col cols="12" sm="6" class="text-truncate">
                <px-indicador-compra-produto
                  class="mr-2"
                  :produto="fornecedor.produtos[index]"
                  small/>
                <px-span-tooltip
                  bottom
                  :text="fornecedor.pessoa.nome"
                  :tooltip="fornecedor.pessoa.nome"/>
              </v-col>
              <v-col cols="12" sm="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">{{ fornecedor.frete.tipoFrete }}&nbsp;
                      <div class="caption">
                        {{ fornecedor.frete.prazoEntrega
                          | pluralize(['dia útil', 'dias úteis']) }}
                      </div>
                    </div>
                  </template>
                  <span>Tipo de frete e prazo de entrega</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <px-forma-pagamento
                        :forma-pagamento="fornecedor.formaPagamento"
                        :prazo-pagamento="fornecedor.prazoPagamento"
                        :show-div="true"/>
                    </span>
                  </template>
                  <span>{{ tooltipFormaPagamento(fornecedor) }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                    {{ totalByFornecedor(fornecedor.produtos)
                      | currency('R$', casaDecimal(fornecedor.produtos)) }}
                    </span>
                  </template>
                  <span>Preço total</span>
                </v-tooltip>
                <div class="caption">
                  {{ filteredProdutos(fornecedor.produtos).length }}
                  / {{ fornecedor.produtos.length }} produto(s)
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
            <v-expansion-panel-content>
                <px-lista-produtos-resposta :produtos="filteredProdutos(fornecedor.produtos)"
                                            @update="emitUpdate"/>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import { uniqBy } from 'lodash';
import currency from 'currency.js';
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import { CasaDecimalUtils } from 'px-components';
import ListaProdutosRespotas from './ListaProdutosRespostas.vue';

export default {
  props: {
    produtos: Array,
  },
  computed: {
    filteredProdutos() {
      return (item) => {
        const produtos = item.filter(p => p.produto.situacao
          === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key);
        return produtos;
      };
    },
    casaDecimal() {
      return (produtos) => {
        const mappedProdutos = produtos.map(produto => produto.produto.cotacaoProduto.produto);
        return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
      };
    },
    tooltipFormaPagamento() {
      return fornecedor => (fornecedor.prazoPagamento ? 'Forma e prazo de pagamento' : 'Forma de pagamento');
    },
    totalByFornecedor() {
      return (produtos) => {
        const precision = this.casaDecimal(produtos);
        return currency(produtos.map(a => a.produto.total)
          .reduce((a, b) => currency(a, { precision })
            .add(currency(b, { precision }))), { precision });
      };
    },
  },
  data() {
    return {
      loading: null,
      fornecedores: null,
    };
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    buildFornecedores() {
      const fornecedores = uniqBy(this.produtos.map(p => this.mapFornecedor(p)), 'id');
      this.fornecedores = fornecedores.map(fornecedor => ({
        ...fornecedor,
        produtos: this.buildProdutos(fornecedor),
      }));
    },
    buildProdutos(fornecedor) {
      return this.produtos
        .filter(produto => produto.fornecedor.id === fornecedor.id)
        .map(p => this.mapProduto(p));
    },
    mapFornecedor(produto) {
      return {
        id: produto.fornecedor.id,
        pessoa: produto.fornecedor.pessoa,
        frete: { ...produto.frete },
        formaPagamento: produto.formaPagamento,
        prazoPagamento: produto.prazoPagamento,
      };
    },
    mapProduto(produto) {
      return {
        ...produto,
        prazoPagamento: undefined,
        formaPagamento: undefined,
        fornecedor: undefined,
        frete: undefined,
      };
    },
  },
  created() {
    this.buildFornecedores();
  },
  components: {
    PxListaProdutosResposta: ListaProdutosRespotas,
  },
};

</script>
<style scoped>
.container {
  padding: 0.9rem;
}
</style>
